import React from "react";
import { LegalPage, H2, H3, P, UL, Address, Note } from "@/components/LegalPage";

export default function Impressum() {
  return (
    <LegalPage title="Impressum" kicker="Rechtliche Angaben">
      <P>Angaben gemäß § 5 TMG.</P>

      <H2 id="anbieter">Anbieter</H2>
      <Address>
        <strong>help4help GmbH</strong>
        <br />
        Oskar-von-Miller-Straße 24
        <br />
        82291 Mammendorf
        <br />
        Deutschland
      </Address>

      <H3 id="standorte">Weitere Standorte</H3>
      <Address>
        <strong>Standort Südost:</strong>
        <br />
        Rathausplatz 1
        <br />
        85579 Neubiberg
      </Address>
      <Address>
        <strong>Standort Ost:</strong>
        <br />
        Seligenthaler Str. 28
        <br />
        84034 Landshut
      </Address>

      <H2 id="vertretung">Vertretungsberechtigte</H2>
      <P>
        Geschäftsführerin Petra Gerum
        <br />
        Geschäftsführerin Martina Brunner
      </P>

      <H2 id="register">Handelsregister</H2>
      <P>
        Registergericht: Amtsgericht München
        <br />
        Handelsregister-Nummer: HRB 243 514
      </P>

      <H2 id="ust">Umsatzsteuer-ID</H2>
      <P>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
        <br />
        <span className="font-mono">DE320699720</span>
      </P>

      <H2 id="kontakt">Kontakt</H2>
      <P>
        Telefon: <a className="text-[#A7B584] hover:text-[#8C9A69] underline underline-offset-4" href="tel:+498145999741">08145 / 99974-18</a>
        <br />
        E-Mail:{" "}
        <a className="text-[#A7B584] hover:text-[#8C9A69] underline underline-offset-4" href="mailto:servus@help4help.de">
          servus@help4help.de
        </a>
      </P>

      <H2 id="redaktion">Redaktionell verantwortlich</H2>
      <Address>
        Petra Gerum
        <br />
        Oskar-von-Miller-Straße 22
        <br />
        82291 Mammendorf
      </Address>

      <H2 id="streit">EU-Streitschlichtung</H2>
      <P>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#A7B584] hover:text-[#8C9A69] underline underline-offset-4"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        . Unsere E-Mail-Adresse finden Sie oben im Impressum.
      </P>

      <H2 id="vsbg">Verbraucherstreitbeilegung / Universalschlichtungsstelle</H2>
      <P>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </P>

      <Note>
        Help4Emergency ist ein Produkt der help4help GmbH. Die Webseite ist unter
        <span className="font-mono"> help4emergency.de</span> erreichbar; die App unter
        <span className="font-mono"> app.help4emergency.de</span>.
      </Note>
    </LegalPage>
  );
}
